<div #divSpinnerModal class="cargandoModal" [style.display]="cargando ? '' : 'none'"><mat-spinner style="margin:0 auto; margin-top: 15%;" ></mat-spinner></div>

<button class="close" mat-button (click)="onNoClick()">X</button>
<h2>Cambiar Foto de Perfil</h2>


<mat-dialog-content>

    <div class="div-file">
        <input type="file" class="fileSelect" #inputFile (change)="cambioArchivo($event)">
        <small *ngIf="archivoCargado" style="color:red;">&nbsp;&nbsp;&nbsp;&nbsp;Debe seleccionar un archivo</small>
    </div>

    <div class="row">
        <div class=" col-sm-12" style="text-align: center;"> 
            <div id="preview" class="profile-preview">
               <img [src]="url" style="display: inline;margin: 0 auto;height: 100%;width: auto;">
            </div>
        </div>
    </div>
    

</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close class="btn-cancelar">Cancel</button>
    <button mat-button (click)="subirArchivo($event)" class="btn-confirmar" >Aceptar</button>
  </mat-dialog-actions>
